export default "__VITE_ASSET__ChX5ZueK__"